import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 68px;
  min-height: 68px;
  position: sticky;
  top: 0;
  border-bottom:1px solid var(--border-color);
  border-top:1px solid var(--border-color);
  padding: .5rem 1rem;
  z-index: 9;
  background-color: var(--main-color);
`;
